import Joi from "joi";
import { TimeHistoryDTO } from "../TimeHistory/TimeHistoryDTO";

export interface StartAndEndExecutionDTO {
    executionStart: Date;
    executionEnd: Date;
    assistanceId: number;
    technicianId: string;
    pending: string | null;
    workDone: string | null;
    counters?: TimeHistoryDTO;
}

export const StartAndEndExecutionDTOSchema = Joi.object({
    technicianId: Joi.string()
        .required()
        .messages({ "string.empty": "Técnico deve de estar selecionado" }),
    executionStart: Joi.date().messages({ "date.base": "Data de início deve de estar preenchida" }),
    executionEnd: Joi.date().messages({ "date.base": "Data de fim deve de estar preenchida" }),
});
